import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import { errorService } from '../../../graphql/utils/utils';
import { graphql, compose, withApollo } from 'react-apollo';
import * as Icons from '@ant-design/icons';

import Loading from '../../common/Loading';

import insertOrganismo from '../../../graphql/mutations/organismos/insertOrganismo.graphql';
import FormCrearOrganismo from './FormCrearOrganismo';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertOrganismo, {
    name: 'insertOrganismo',
  })
)
class CrearOrganismo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      organismo: {},
      loading: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  guardarOrganismo = organismo => {
    // console.log('Guardar organismo llega =>', organismo);

    this.setState({ ...this.state, loading: true });

    this.props
      .insertOrganismo({
        variables: {
          organismo: organismo,
        },
      })
      .then(res => {
        // console.log('Response de insert organismo => ', res);
        notification.success({
          message: 'Se guardó correctamente',
          description: 'Se han registrado los nuevos datos del organismo',
        });
        this.setState({ ...this.state, loading: false });

        this.props.history.push('/admin/organismos');
      })
      .catch(err => {
        this.setState({ ...this.state, loading: false });
        console.log('Error en la carga del organismo');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
          organismo: organismo,
        });
        Modal.error({
          title: 'Error en la creacion del organismo',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Organismo</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Organismo
          </h2>
          <br />
          <div style={estiloContent}>
            <FormCrearOrganismo
              className="formularios"
              onSubmit={this.guardarOrganismo}
              onAnterior={() => this.props.history.push('/admin/organismos')}
              usuario={this.props.usuario}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearOrganismo);
